import { getWishlistAction } from "@/actions/wishlist";
import { useMarket } from "@app/_context";
import { CustomProduct } from "@apptus/esales-api";
import useAuth from "@features/auth/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { getWishlistFromLocalStorage } from "../utils/localWishlistStorage";

export default function useWishlistItem(product: CustomProduct) {
  const { market } = useMarket().state;
  const { token, user, loading, initializing } = useAuth();

  return useQuery({
    queryKey: ["wishlist", token ?? "guest"],
    queryFn: async () => {
      if (!token) {
        return getWishlistFromLocalStorage();
      }

      return getWishlistAction({
        token,
        pageSize: 1000,
        locale: market.serviceLocale,
      });
    },
    enabled: !loading && !initializing && (!user || Boolean(token)),
    select: (data) =>
      data.wishlistItems?.find(
        (item) =>
          product.variants[0]?.key === item.variantId &&
          product.key === item.productId,
      ),
  });
}
